module.exports = __webpack_public_path__ + "img/artillery-wagon-cannon-barrel-shadow-9.a046727e.png";